import { IconButton } from "@shared/components/icon-button";
import { ICON_SIZE, ICON_VARIANT } from "@shared/components/icon-button/types";
import ArrowRightIcon from "@svg/new-design/arrow-right";
import Link from "next/link";
import { FC } from "react";

interface Props {
  isAdmin: boolean;
  profileMenu: { id: string; name: string }[];
  selected?: string;
  backButton?: {
    label: string;
    href: string;
  };
  element?: React.ReactElement;
}

const MobileProfileHeader: FC<Props> = ({
  isAdmin,
  profileMenu,
  selected = "profile",
  backButton,
  element,
}) => {
  const mobileNavbarTop = isAdmin ? "50px" : "0px";

  return (
    <nav
      className="fixed z-layout flex h-14 w-full min-w-0 items-center justify-between gap-x-1.5 overflow-x-clip bg-fds-primary pl-2 shadow-sm"
      style={{ top: mobileNavbarTop }}
    >
      <div className="flex min-w-0 flex-1 items-center">
        <Link href={backButton?.href || "/my-account"} className="shrink-0">
          <IconButton
            icon={<ArrowRightIcon />}
            size={ICON_SIZE.MEDIUM}
            variant={ICON_VARIANT.DEFAULT}
            aria-label="بازگشت"
          />
        </Link>

        <p className="min-w-0 truncate title-lg text-fds-primary">
          {backButton?.label ||
            profileMenu.find((item) => item.id === selected)?.name ||
            "پروفایل"}
        </p>
      </div>

      {element ? <div className="shrink-0">{element}</div> : null}
    </nav>
  );
};

export default MobileProfileHeader;
